import React from "react";
import { useDispatch } from "react-redux";
import { InfoIcon } from "../../../../assets/images/svg/svg";
import AddOnSelect from "../Modal/Addons";

function useProductVariantColumn(handleProductModal) { // Accept the function as an argument
  const dispatch = useDispatch();

  const productVariant = [
    {
      header: "Product",
      accessorKey: "name",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
    {
      header: "Category",
      accessorKey: "product_category",
      cell: (props) => (props?.getValue() ? props?.getValue() : "-"),
      size: 200,
    },
  ];

  return { productVariant };
}

export default useProductVariantColumn;
